import { Anchor, AnchorProps } from '@mantine/core';
import React from 'react';
import { Link } from 'react-router-dom';

export interface IAnchorLinkProps
  extends Omit<AnchorProps, 'component' | 'to' | 'children'>,
    Pick<
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
      'target' | 'rel' | 'download' | 'aria-label' | 'onClick'
    > {
  to: string;
  children: React.ReactNode;
}

/** @registry Mantine Anchor rendered as a react-router Link; use for in-app navigation styled as inline text. Permanently exempted from lib's no-router-import rule. */
export const AnchorLink: React.FC<IAnchorLinkProps> = ({
  children,
  to,
  ...props
}) => {
  return (
    <Anchor component={Link} to={to} {...props}>
      {children}
    </Anchor>
  );
};
